import { NgModule } from '@angular/core';
import Pubnub, { PubnubConfig } from 'pubnub';

import { PUBNUB_FACTORY } from './pubnub-lib.interface';

export const pubnubFactory = (c: PubnubConfig) => new Pubnub(c);

@NgModule({
  imports: [
  ],
  providers: [
    { provide: PUBNUB_FACTORY, useValue: pubnubFactory },
  ]
})
export class PubnubLibModule { }
